import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { REPORT_NAME, USER_TYPE } from "../../constant/reportType";
import Form from 'react-bootstrap/Form';
import { Switch, Table } from "antd";
import { alertMessage } from "../../utils/AlertService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { PDF_USAGE_LOGS_COLULMN } from "../../constant/AppConstant";
import { useDeletePdfUsageByIdMutation, useGetAllPdfUsageLogsWithPaginationMutation, useGetAllPdfUsageLogsWithSearchMutation } from "../../redux-toolkit/services/privateLibraryService";
import { getPdfUsageLogsDetails, getPdfUsageLogsDetailsSearch, getPdfUsageLogsTotalRecords, setPdfUsageLogs, setPdfUsageLogsBySearch } from "../../redux-toolkit/slices/privateLibrarySlice";
import { getLocalStorageData } from "../../utils/LocalStorageService";



type Props = {};
const PDFUsageLogs = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const inputRef = useRef<HTMLInputElement>(null);
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;


    //state
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [call, setCall] = useState("N");

    //getMutations
    const [getAllPdfUsageLogs, allPdfUsageLogsResponse] = useGetAllPdfUsageLogsWithPaginationMutation();


    //delete Mutation
    const [deletePdfUsageLogLibrary, deletePdfUsageLogLibraryResponse] = useDeletePdfUsageByIdMutation();

    //search Mutation 
    const [getAllPdfLogsWithSearch, getAllPdfLogsWithSearchResponse] = useGetAllPdfUsageLogsWithSearchMutation();


    //totalRecords
    const totalPdfUsageLogs = useAppSelector(getPdfUsageLogsTotalRecords);
    const allPdfUsageLogs: any = useAppSelector(getPdfUsageLogsDetails);
    const allPdfUsageLogsSearch: any = useAppSelector(getPdfUsageLogsDetailsSearch);


    useEffect(() => {
        setReportName(REPORT_NAME.PDF_USAGE_LOGS);
    }, []);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "action",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true
                                    ? "bg-primary"
                                    : "bg-secondary"
                                    }`}
                                checked={
                                    record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                    </div>
                );
            },
        };

        // Build the column list
        if (reportName === REPORT_NAME.PDF_USAGE_LOGS && PDF_USAGE_LOGS_COLULMN) {
            PDF_USAGE_LOGS_COLULMN.forEach((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }

    }, [reportName, params.reportType]);




    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.PDF_USAGE_LOGS && localUserObj?.userType === USER_TYPE.ADMIN) {
            deletePdfUsageLogLibrary({ id: record.id });
        }
    };

    useEffect(() => {
        if (deletePdfUsageLogLibraryResponse.isSuccess) {
            if (deletePdfUsageLogLibraryResponse.data?.isActive) {
                alertMessage("PDF usage log re-enabled successfully", "success");
            } else {
                alertMessage("PDF usage log deleted successfully", "success");
            }
            setCall("Y");
        } else if (deletePdfUsageLogLibraryResponse.isError) {
            alertMessage("Error while updating PDF usage log", "error");
        }
    }, [deletePdfUsageLogLibraryResponse.isSuccess, deletePdfUsageLogLibraryResponse.isError]);


    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.PDF_USAGE_LOGS) {
                getAllPdfUsageLogs({
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                });
                setCall("N");
            }
        }
    }, [call]);


    useEffect(() => {
        if (reportName === REPORT_NAME.PDF_USAGE_LOGS) {
            getAllPdfUsageLogs({
                page: currentpage - 1,
                size: pageSize,
                sort: "id",
            });
        }
    }, [reportName]);


    useEffect(() => {
        if (allPdfUsageLogsResponse.isSuccess) {
            dispatch(setPdfUsageLogs(allPdfUsageLogsResponse));
        } else if (allPdfUsageLogsResponse.isError) {
            let response: any = allPdfUsageLogsResponse.error;
            alertMessage(response, "error");
        }
    }, [allPdfUsageLogsResponse.isSuccess, allPdfUsageLogsResponse.isError]);

    useEffect(() => {
        if (allPdfUsageLogs && reportName === REPORT_NAME.PDF_USAGE_LOGS) {
            setDatasource(allPdfUsageLogs);
        }
    }, [allPdfUsageLogs]);

    useEffect(() => {
        if (allPdfUsageLogsSearch && reportName === REPORT_NAME.PDF_USAGE_LOGS) {
            setDatasource(allPdfUsageLogsSearch);
        }
    }, [allPdfUsageLogsSearch]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.PDF_USAGE_LOGS) {
            getAllPdfUsageLogs({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleSearch = () => {
        const value: any = inputRef.current?.value;
        setSearchValue(value)
        console.log("Search text:", value);
        if (reportName === REPORT_NAME.PDF_USAGE_LOGS) {
            getAllPdfLogsWithSearch({
                token: token,
                payload: { offset: pageSize, pageNumber: currentpage - 1, searchBy: value },
            });
        }
    };

    useEffect(() => {
        if (reportName === REPORT_NAME.PDF_USAGE_LOGS) {
            getAllPdfLogsWithSearch({
                token: token,
                payload: { offset: pageSize, pageNumber: currentpage - 1, searchBy: searchValue },
            });
        }
    }, [searchValue]);

    useEffect(() => {
        if (getAllPdfLogsWithSearchResponse.isSuccess) {
            dispatch(setPdfUsageLogsBySearch(getAllPdfLogsWithSearchResponse));
        } else if (getAllPdfLogsWithSearchResponse.isError) {
            let response: any = getAllPdfLogsWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllPdfLogsWithSearchResponse.isSuccess, getAllPdfLogsWithSearchResponse.isError]);


    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-cm-active-primary1"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                ref={inputRef}
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                            <div
                                className="input-group-append bg-cm-light-primary1 p-1 rounded-end"
                                onClick={handleSearch}
                                style={{ cursor: "pointer" }}
                            >
                                <button className="btn btn-outline-primary" type="button">
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.PDF_USAGE_LOGS:
                                    return totalPdfUsageLogs;
                                default:
                                    return dataSource.length;
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default PDFUsageLogs;